module.exports = __webpack_public_path__ + "static/media/hero-car-category.45244e0d.png";